
import Vue from 'vue';
import { HTTP } from '@/utils/http-common';
export default Vue.extend({
  name: 'Newsletter',
  data() {
    return {
      form: {
        name: '',
        gender: '',
        group: '',
        city: '',
        email: '',
      },
      newsletterAgreement: false,
      rodoAgreement: false,
      loading: false,
      formAccepted: false,
      formError: false,
      longAgreement: false,
      longRodo: false,
    };
  },
  methods: {
    submit() {
      this.loading = true;
      const formData = new FormData();
      Object.entries(this.form).forEach(([key, value]) => {
        formData.set(key, value);
      });
      HTTP.post('proxy.php', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }).then((response) => {
        if (response.data.status === 'OK') {
          this.formAccepted = true;
          this.form.name = '';
          this.form.gender = '';
          this.form.group = '';
          this.form.city = '';
          this.form.email = '';
          this.rodoAgreement = false;
          this.newsletterAgreement = false;
        } else {
          this.formError = response.data.status;
        }
        this.loading = false;
      }).catch((e) => {
        this.formError = true;
        this.loading = false;
      });
    },
    showFullAgreement(type: string) {
      type === 'newsletter' ? this.longAgreement = !this.longAgreement : this.longRodo = !this.longRodo;
    },
  },
});
